<template>
  <section class="campaigns">
    <table class="w-full">
      <thead>
        <tr class="text-xl text-green font-bold bg-primary">
          <td class="p-2">Product Name</td>
          <td class="p-2 text-center">Qty.</td>
          <td class="p-2 text-center">Equivalized Qty.</td>
        </tr>
      </thead>

      <tbody
        v-for="campaign in campaigns"
        :key="campaign.id"
      >
        <template v-if="campaignTotal(campaign.title) > 0">
          
        <tr class="bg-lime text-white text-xl font-bold">
          <td colspan="3" v-html="campaign.title" class="p-2" />
        </tr>

        
        <tr
          v-for="item in displayProducts(campaign.title)"
          :key="item.id"
          class="bg-light-grey"
        >
          <td v-html="item.title" class="border divide-primary p-2" />
          <td v-html="item.qty" class="border divide-primary p-2 align-top text-center" />
          <td v-html="equivalized(item)" class="border divide-primary p-2 align-top text-center" />
        </tr>
        <tr class="font-bold">
          <td class="border divide-primary text-right">Campaign Total:</td>
          <td v-html="campaignTotal(campaign.title)" class="border divide-primary text-center" />
          <td v-html="campaignEqTotal(campaign.title)" class="border divide-primary text-center" />
        </tr>
        </template>
      </tbody>

      <tfoot>
        <tr class="text-xl text-green font-bold bg-primary">
          <td class="p-2 uppercase">Seasonal Total</td>
          <td v-html="seasonalTotal" class="p-2 align-top text-center" />
          <td v-html="totalEquivalized" class="p-2 align-top text-center" />
        </tr>
      </tfoot>
    </table>
  </section>
</template>

<script>
export default {
  name: 'CampaignStats',
  props: {
    campaigns: Array,
    seasonals: Array,
    portables: Array,
    orderedItems: Array,
  },
  data () {
    return {
      stats: []
    }
  },
  mounted () {
    this.statsParser();
  },
  computed: {
    seasonalTotal () {
      let total = 0;

      this.stats.forEach(record => {
        total = total + record.totalQty;
      });

      return total;
    },
    totalEquivalized () {
      let total = 0;
      
      this.stats.forEach(record => {
        total = total + record.totalEqQty;
      });

      return total;
    }
  },
  methods: {
    statsParser () {
      this.campaigns.forEach((campaign) => {
        let record = {
          title: campaign.title,
          campaignId: campaign.id,
          items: [], //this.campaignProducts(campaign.id),
          totalQty: 0,
          totalEqQty: 0
        }

        record.items.forEach(statItem => {
          statItem.qty = 0
        })
        
        this.orderedItems.forEach(orderedItem => {
          if (orderedItem.campaignId === campaign.id) {
            let item = record.items.find(statItem => statItem.id === parseInt(orderedItem.id))
            
            if (item !== undefined) {
              item.qty += orderedItem.qty;
            } else {
              record.items.push({
                id: parseInt(orderedItem.id),
                title: orderedItem.title,
                equivalized: orderedItem.equivalized,
                qty: orderedItem.qty
              });
            }

            record.totalQty += orderedItem.qty;
            record.totalEqQty += (orderedItem.qty * orderedItem.equivalized);
          }
        })
        console.log(record);

        this.stats.push(record);
      });
    },
    campaignProducts (campaign) {
      return this.seasonals.filter(prod => {
        return prod.campaignId == campaign
      });
    },
    campaignTotal (campaign) {
      const record = this.stats.find(stat => stat.title === campaign);
      return record === undefined ? 0 : record.totalQty;
    },
    campaignEqTotal (campaign) {
      const record = this.stats.find(stat => stat.title === campaign);
      return record === undefined ? 0 : record.totalEqQty;
    },

    displayProducts(campaign) {
      const products = this.stats.find(stat => stat.title === campaign);
      return products === undefined ? [] : products.items;
    },
    equivalized (item) {
      return item.qty * parseInt(item.equivalized);
    }
  }
}
</script>
